import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicStyleLoaderService } from '../../utilities/dynamic-style-loader';

@Component({
    selector: 'my-account-placeofbirth',
    templateUrl: './place-of-birth.component.html',
    styleUrls: [],
    standalone: false
})
export class PlaceofbirthComponent implements OnInit {

  dialogData:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dynamicStyleLoader: DynamicStyleLoaderService) {
    this.dialogData = data.parentInstance;
   }  

  ngOnInit(): void {
    this.dynamicStyleLoader.focusCloseButton('mob-focus-place-of-birth','desktop-focus-place-of-birth');  
  }

}
